import YoutubePlayer from "./YouTube";
import VimeoPlayer from "./Vimeo";
/**
 * Video functionality
 * @class
 */
export default class Video {
    /**
     * @constructor
     * @param {HTMLElement} element The video root element
     */
    constructor(element) {
        this.el = element;
        this.provider = this.el.getAttribute('data-provider') || "";
        this.videoId = this.el.getAttribute('data-video-id') || "";
        if (this.provider === 'youTubeVideo') {
            this.loadYouTubeApi();
            new YoutubePlayer(this.el, this.videoId);
        }
        if (this.provider === 'vimeoVideo') {
            this.loadVimeoApi();
            new VimeoPlayer(this.el, this.videoId);
        }
        // console.log('Video', this)
    }
    loadYouTubeApi() {
        var _a;
        const apiScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
        if (!apiScript) {
            const tag = document.createElement('script');
            const firstScriptTag = document.getElementsByTagName('script')[0];
            tag.src = 'https://www.youtube.com/iframe_api';
            (_a = firstScriptTag === null || firstScriptTag === void 0 ? void 0 : firstScriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(tag, firstScriptTag);
        }
    }
    loadVimeoApi() {
        var _a;
        const apiScript = document.querySelector('script[src="https://player.vimeo.com/api/player.jsi"]');
        if (!apiScript) {
            const tag = document.createElement('script');
            const firstScriptTag = document.getElementsByTagName('script')[0];
            tag.src = 'https://player.vimeo.com/api/player.js';
            (_a = firstScriptTag === null || firstScriptTag === void 0 ? void 0 : firstScriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(tag, firstScriptTag);
        }
    }
    /**
     * Creates new instances of IVideoUtils for each `[data-component="Video"]` element,
     * and adds the necessary event listeners to support opening and closing of the video.
     */
    static init() {
        const VideoEls = document.querySelectorAll('[data-component="Video"]');
        VideoEls.forEach(video => new Video(video));
    }
}
